export const FORM_NAME = 'workOrderHouseholdPreferencesForm';
export const DEFAULT_SELECTED_ENTRY_PERMISSION = 'No Preference';
